var Operator;
(function (Operator) {
    Operator["and"] = "and";
    Operator["contains"] = "contains";
    Operator["eq"] = "eq";
    Operator["gte"] = "gte";
    Operator["gt"] = "gt";
    Operator["in"] = "in";
    Operator["lte"] = "lte";
    Operator["lt"] = "lt";
    Operator["ne"] = "ne";
    Operator["or"] = "or";
    Operator["term"] = "term";
    Operator["none"] = "none";
})(Operator || (Operator = {}));
export default Operator;
